const t = ["htm", "html"], l = (s) => {
  var e;
  try {
    const n = new URL(s, window.location.origin).pathname.split("/").pop();
    if (!n) return { isDownload: !1 };
    if (!n.includes(".")) return { isDownload: !1 };
    const o = (e = n.split(".").pop()) == null ? void 0 : e.toLowerCase();
    return o ? t.includes(o) ? { isDownload: !1 } : {
      isDownload: !0,
      extension: o,
      fileName: n
    } : { isDownload: !1 };
  } catch {
    return { isDownload: !1, extension: "", fileName: "" };
  }
};
export {
  l as getDownloadLinkInfo
};
